module.exports = __webpack_public_path__ + "img/pulse-iot-center_001.8d0967d1.webp";